import { BADGES, type PlayerStats } from '@accra/shared';
import type { BadgeProgress } from '../../net/challenges';
import { el } from '../components/el';

function goalText(stat: keyof PlayerStats, value: number): string {
  return stat === 'metres' ? `${(value / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })} km` : Math.floor(value).toLocaleString();
}

/** Every badge, earned or not, with how far along you are. */
export function badgesView(progress: BadgeProgress | null): HTMLElement {
  const wrap = el('div', 'me-view');
  if (!progress) {
    wrap.append(el('p', 'empty', 'Offline: your badges need a connection.'));
    return wrap;
  }
  const earned = new Set(progress.earned.map((b) => b.id));
  const grid = el('div', 'badge-grid');
  for (const badge of BADGES) {
    const have = earned.has(badge.id);
    const value = Math.min(progress.stats[badge.stat], badge.goal);
    const card = el('div', have ? 'badge-card earned' : 'badge-card');
    const bar = el('div', 'badge-bar');
    const fill = el('div', 'badge-fill');
    fill.style.width = `${(value / badge.goal) * 100}%`;
    bar.append(fill);
    const text = el('div', 'badge-text');
    text.append(el('b', '', badge.name), el('small', '', badge.blurb), have ? el('small', 'badge-done', '✓ Earned') : el('small', '', `${goalText(badge.stat, value)} / ${goalText(badge.stat, badge.goal)}`), have ? el('span') : bar);
    card.append(el('span', 'badge-big', badge.icon), text);
    grid.append(card);
  }
  wrap.append(el('p', 'muted', `${earned.size} of ${BADGES.length} earned. They show next to your name on the leaderboard.`), grid);
  return wrap;
}
